import { render, staticRenderFns } from "./integralInfo.vue?vue&type=template&id=07fccb18&"
import script from "./integralInfo.vue?vue&type=script&lang=js&"
export * from "./integralInfo.vue?vue&type=script&lang=js&"
import style0 from "./integralInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports